import { useState, useEffect } from 'react';
import { DashboardData } from '../models/DashboardModels';
import { DashboardService } from '../services/DashboardService';
import { formatNumber, formatChange } from '../utils/numberFormatter';

// 대시보드 ViewModel 훅
export const useDashboardViewModel = () => {
  // 상태 관리
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedDate, setSelectedDate] = useState<string>(new Date().toISOString().split('T')[0]);

  // 대시보드 데이터 로드 (실제 API 호출)
  const loadDashboardData = async (date?: string) => {
    try {
      setLoading(true);
      setError(null);

      // 실제 API 호출 시도, 실패하면 목업 데이터 사용
      try {
        const data = await DashboardService.getDashboardDataFromAPI(date || selectedDate);
        setDashboardData(data);
        console.log('실제 API 데이터 로드 성공:', data);
      } catch (apiError) {
        console.warn('실제 API 호출 실패:', apiError);
        setError('대시보드 데이터를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      setError('대시보드 데이터를 불러오는데 실패했습니다.');
      console.error('Dashboard data loading error:', err);
    } finally {
      setLoading(false);
    }
  };

  // 날짜 변경 핸들러
  const handleDateChange = (date: string) => {
    setSelectedDate(date);
    loadDashboardData(date);
  };

  // 페이지 변경 핸들러
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // 데이터 새로고침
  const refreshData = () => {
    loadDashboardData();
  };

  // 증감률 계산 유틸리티 - 새로운 포맷팅 함수 사용
  const getChangeIndicator = (value: number) => {
    return formatChange(value);
  };

  // 퍼센티지 계산
  const calculatePercentage = (value: number, total: number) => {
    return ((value / total) * 100).toFixed(1);
  };

  // 컴포넌트 마운트 시 데이터 로드
  useEffect(() => {
    loadDashboardData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    // 상태
    dashboardData,
    loading,
    error,
    currentPage,
    selectedDate,

    // 액션
    handlePageChange,
    handleDateChange,
    refreshData,

    // 유틸리티
    getChangeIndicator,
    formatNumber,
    calculatePercentage
  };
}; 